<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <i class="fa fa-copyright" aria-hidden="true"></i>
      2022
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String,
  },
};
</script>
